'use strict'

export default {
  /* API */
  HTTP_CONFIG: {
    authURL: process.env.SERVER_AUTH_URL,
    baseURL: process.env.SERVER_BASE_URL,
    //baseURL: 'http://localhost:8081',
    //baseURL: 'http://52.141.1.183',  // 개발
    timeout: 30000,
    crossDomain: true,
    withCredentials: false,
    debug: process.env.NODE_ENV === 'development'
  },

  /* 외부 URL사용 정보. */
  EXTERNAL_URL: {
    taxinvoiceURL: process.env.TAXINVOICE_URL,
    paymentreqURL: process.env.PAYMENT_REQ_URL,
    paymentlayerURL: process.env.PAYMENT_LAYER_URL,
    billingcardregURL: process.env.BILLINGCARD_REG_URL
  },

  /* 사용자 권한 */
  USER_AUTH: {
    SYSTEM_ADMIN: '00',
    MANAGER: '10',
    AGENT: '20',
    B2B2C: '30',
    SHOP: '40',
    VENDOR: '50',
    INSURANCE: '60',
    LOGISTICS: '70',
    VIEWER: '80'
  },

  /* 이미지 사용 구분 */
  IMAGE_TYPE: {
    QUOTATION: '10', // 견적
    PRODUCT: '20',   // 상품
    BOARD: '30'      // 게시판
  },

  /* 보험사 번호 */
  INSURANCE: {
    SAMSUNG: 'SA10000095',
    HYUNDAI: 'SA10000093',
    DONGBOO: 'SA10000094'
  },

  /* 상품상태 코드 */
  PRODUCT_STATUS: {
    NORMAL: '10',
    UNSTOCKED: '20',
    DISCONTINUED: '30',
    ERP_REQUEST: '40',
    ERP_ERROR: '50'
  },

  /* 주문구분 코드 */
  ORDER_TYPE: {
    GENERAL_QUOTATION: '11',    // 일반견적
    GENERAL_ORDER: '12',        // 일반주문
    LOCAL_QUOTATION: '21',      // 로컬견적
    LOCAL_ORDER: '22',          // 로컬주문
    SELF_ORDER: '31',            // 자체조달
    TAX_BILL: '32',             // 세금계산서발행
    TEMP_ORDER: '40',           // 임시
    WAITING_ORDER: '41',        // 주문대기
    NO_STOCK: '42',            // 미재고
    SHIPPING_FEE: '50',         // 배송비
    RETURN_PENALTY: '60',       // 반품 패널티
    GENERAL_RETURN: '81',        // 일반반품
    LOCAL_RETURN: '82',         // 로컬반품
    GENERAL_CANCEL: '91',        // 일반취소
    LOCAL_CANCEL: '92',          // 로컬취소
    ITEM_REMOVE: '93'            // 아이템삭제
  },

  ORDER_CLASS: {
    GENERAL: '11',              //일반
    GENERAL_INSURANCE: '12',    //일반보험
    LOCAL: '21',                //로컬
    LOCAL_INSURANCE: '22',      //로컬보험
    CARPOS: '31',               //카포스
    B2B2C: '41',                //B2B2C
    SPEED_MATE: '51'            //스피드메이트
  },

  /* 주문 상태 코드 */
  ORDER_STATUS_CODE: {
    CREATE_QUOTE: '10',            //견적작성
    REQUEST_QUOTE: '11',           //견적요청
    QUOTATION_CONFIRMATION: '12',  //견적확정
    QUOTE_RECEPTION: '13',         //견적접수
    QUOTATION_COMPLETED: '14',     //견적완료
    CREATE_ORDER: '20',            //주문작성
    ORDER_REQUEST: '21',           //주문요청
    ORDER_CONFIRMATION: '22',      //주문확정
    LOGISTICS_PROCESSING: '23',   //입출고요청
    LOGISTICS_CONFIRM: '24',      //입출고확정
    INCOME_OUTCOME: '25',         //매입매출
    CONFIRMATION_PAYMENT: '26',   //지급확정
    LOCAL_CREATE_QUOTE: '30',     //견적작성
    LOCAL_REQUEST_QUOTE: '31',    //견적요청
    LOCAL_TMP_CONFIRMATION: '32', //견적임시확정
    LOCAL_CONFIRMATION: '33',     //견적확정
    LOCAL_CREATE_ORDER: '40',     //주문작성
    LOCAL_ORDER_REQUEST: '41',    //주문요청
    LOCAL_ORDER_TMP_CONFIRMATION: '42',  //주문임시확정
    LOCAL_ORDER_CONFIRMATION: '43',  //주문확정
    CANCEL: '90',
    OUT_STOCK_ENDS: '98',
    DIVISION_END: '97',
    END: '99'
  },

  /* 협력사 구분 코드 */
  PARTNER_TYPE_CODE: {
    PARTNER_SKN: '10',                   // SK네트웩스
    PARTNER_AGENCY: '20',                // 대리점
    PARTNER_COMPONENT_SUPPORT_CENTER: '30',    // 부품지원센터
    PARTNER_SPEEDMATE: '40',             // 스피드메이트
    PARTNER_CARPOS: '50',                // 카포스
    PARTNER_INSURANCE: '60',             // 보험사
    PARTNER_B2B2C: '70',                 // B2B2C
    PARTNER_LOGISTIC: '80',              // 물류센터
    PARTNER_REPAIRSHOP: '90'             // 수리공장
  },

  /* 부가가치세 */
  VALUE_ADDED_TAX: {
    RATIO: 0.1,
    PERCENTAGE: 10
  },

  /* 물류센터 코드 */
  LOGISTICS_TYPE_CODE: {
    ANSEONG: "D507",			      // 안성물류
    SEOUL: "D510"				      // 서울물류
  },

  /* 결제 구분 코드 */
  PAYMENT_TYPE_CODE: {
    LOAN: '10',				        // 여신
    CREDIT_CARD: '20',		      // 신용카드
    CASH: '30'  			          // 현금
  },

  /* 보험 상태 코드 */
  INSURANCE_CLAIM_STATUS: {
    APPROVAL_REQEUST: '10',    // 승인요청
    APPROVAL_COMPLETE: '20',   // 승인완료
    APPROVAL_REJECT: '30',     // 승인반려
    SUBMIT: '40',              // 제출
    NOTIFICATION: '50'         // 보험사통보
  },

  /* API 결과 코드 */
  HTTP_RESPONSE_SUCCESS: '200',   // 성공
  DUP_PK: '601',					        // pk 중복
  DUP_REQ_PK: '602',					    // 등록 요청 목록의 pk 중복
  NOT_VALID_AGUMENT: '701',       // validation 오류
  NOT_LOGIN: '801',               // 로그인 정보 없음
  LOGIN_FAIL: '802',              // 로그인 실패
  UNAUTHORIZATION: '803',         // 권한 오류
  AUTH_NUMBER_FAIL: '804',		    // 인증 번호 인증 실패
  NO_ID: '805',                   // 존재하지 않는 ID
  NOT_EXIST_PHONE: '806',         // 휴대폰 번호 없음
  EXIST_PHONE: '807',              // 휴대폰 번호 있음
  ACCOUNT_LOCKOUT: '808',			    // 계정잠금
  FILE_UPLOAD_FAIL: '901',		    // 파일 업로드 실패
  FILE_DOWNLOAD_FAIL: '902',		  // 파일 다운로드 실패
  DB_ERROR: '590',                // DB 에러
  ERROR: '599',                    // 오류

  /* 간편로그인 client_id */
  NAVER_CLIENT_ID: process.env.NAVER_CLIENT_ID,
  KAKAO_CLIENT_ID: process.env.KAKAO_CLIENT_ID,

  /* kcp site_cd */
  KCP_NORMAL: process.env.KCP_NORMAL,
  KCP_SIMPLE: process.env.KCP_SIMPLE,
  KCP_FORM_URL : process.env.KCP_FORM_URL,
  KCP_RET_URL : process.env.KCP_RET_URL,

  /* cookie domain*/
  COOKIE_DOMAIN : process.env.COOKIE_DOMAIN,
}


// WEBPACK FOOTER //
// ./src/config.js